import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CharacterList from './components/CharacterList';
import CharacterForm from './components/CharacterForm';
import CharacterEdit from './components/CharacterEdit';
import GiftList from './components/GiftList';
import GiftForm from './components/GiftForm';
import GiftEdit from './components/GiftEdit';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { Users, Settings, LogOut, Menu, X, Package } from 'lucide-react';

const App: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    window.location.href = '/login';
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
      <div className="min-h-screen bg-gray-50 flex">
        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}
        
        {/* Sidebar */}
        <aside className={`fixed md:static inset-y-0 left-0 z-30 w-64 bg-gray-900 text-white transition-transform duration-300 transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}>
          <div className="p-6 border-b border-gray-800">
            <h1 className="text-xl font-bold">Viora Admin</h1>
          </div>
          <nav className="p-4">
            <ul className="space-y-2">
              <li>
                <a href="/" className={`flex items-center p-3 rounded-lg transition ${
                  window.location.pathname === '/' 
                    ? 'bg-gray-800 text-white' 
                    : 'hover:bg-gray-800 text-gray-300 hover:text-white'
                }`}>
                  <Users size={18} className="mr-3" />
                  <span>Karakterler</span>
                </a>
              </li>
              <li>
                <a href="/gifts" className={`flex items-center p-3 rounded-lg transition ${
                  window.location.pathname.startsWith('/gifts') 
                    ? 'bg-gray-800 text-white' 
                    : 'hover:bg-gray-800 text-gray-300 hover:text-white'
                }`}>
                  <Package size={18} className="mr-3" />
                  <span>Hediyeler</span>
                </a>
              </li>
              <li>
                <a href="#" className="flex items-center p-3 rounded-lg hover:bg-gray-800 text-gray-300 hover:text-white transition">
                  <Settings size={18} className="mr-3" />
                  <span>Ayarlar</span>
                </a>
              </li>
              <li className="mt-8">
                        <button
                          onClick={handleLogout}
                          className="w-full flex items-center p-3 rounded-lg hover:bg-gray-800 text-gray-300 hover:text-white transition"
                        >
                  <LogOut size={18} className="mr-3" />
                  <span>Çıkış Yap</span>
                        </button>
              </li>
            </ul>
          </nav>
        </aside>
        
        {/* Main content */}
        <main className="flex-1 overflow-y-auto">
          {/* Header */}
          <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-10">
            <div className="px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
              <button 
                className="md:hidden p-2 rounded-md text-gray-600 hover:bg-gray-100"
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
              </button>
              <div className="text-xl font-semibold text-gray-800 hidden md:block">
                AI Girlfriend Yönetim Paneli
              </div>
              <div className="flex items-center space-x-4">
                <span className="text-sm text-gray-600">Admin</span>
                <div className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-medium">
                  A
                </div>
              </div>
            </div>
          </header>
          
          {/* Page content */}
          <div className="px-4 sm:px-6 lg:px-8 py-6">
            <Routes>
              <Route path="/" element={<CharacterList />} />
              <Route path="/create" element={<CharacterForm />} />
              <Route path="/edit/:id" element={<CharacterEdit />} />
              <Route path="/gifts" element={<GiftList />} />
              <Route path="/gifts/create" element={<GiftForm />} />
              <Route path="/gifts/edit/:id" element={<GiftEdit />} />
            </Routes>
          </div>
        </main>
      </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
